import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  clickableArea: {
    cursor: "pointer",
    width: "100%",
    height: "100%",
    pointerEvents: "all",
  },
  mobileJoinRoom: {
    background: "#12ff1d4b",
    border: "4px solid #1e8624",
    borderRadius: "10px",
    stroke: "#1e8624",
    strokeWidth: "4px",
    fill: "#12ff1d4b",
  },
  outlined: {
    borderWidth: "4px",
    borderStyle: "solid",
    borderImage: `linear-gradient(to right,  ${theme.palette.blue.dark}, ${theme.palette.blue.main}) 1`,
  },
}));
